import Campaign from 'mini-campaign/lib/store/Campaign';
import Journey from 'mini-campaign/lib/store/Journey';
import { CampaignLightningId } from 'mini-campaign-bootstrap/lib/utils/CampaignLightningId';
import { CampaignModal, CampaignModalConfig } from 'mini-campaign-types/lib/CampaignModal';
import { CampaignTooltip, CampaignTooltipConfig } from 'mini-campaign-types/lib/CampaignTooltip';
import { waitBeforeStart } from '../utils/waitBeforeStart';
import {
    CampaignEmbeddedMessage,
    CampaignEmbeddedMessageConfig,
} from 'mini-campaign-types/lib/CampaignEmbeddedMessage';

const DELAY_AFTER_RENDER_IN_MILLISECONDS = 2000;

let mailCalendarNudgeCampaign: Campaign<CampaignTooltipConfig> = null;
let mailCalendarNudgeJourney: Journey = null;
let mailWarmWelcomeCampaign: Campaign<CampaignModalConfig> = null;
let mailWarmWelcomeJourney: Journey = null;
let mailFocusedOthersCampaign: Campaign<CampaignEmbeddedMessageConfig> = null;
let mailMultiSelectCampaign: Campaign<CampaignEmbeddedMessageConfig> = null;
let mailEdgeUpsellCampaign: Campaign<CampaignEmbeddedMessageConfig> = null;

let isMailCampaignObjectsInitialized = false;

function initializeMailCampaignObjects() {
    /**
     * Mini Mail campaign object
     */
    mailCalendarNudgeCampaign = new Campaign<CampaignTooltipConfig>({
        id: 'CALENDAR_NUDGE_CAMPAIGN',
        rule: () => true,
        lightningId: CampaignLightningId.MiniCalendarModuleSwitch,
        actionTypes: { onUserDismiss: 'Primary', onUnmount: 'Primary' },
        campaignType: new CampaignTooltip(),
    });

    mailCalendarNudgeJourney = new Journey(async () => {
        await waitBeforeStart(DELAY_AFTER_RENDER_IN_MILLISECONDS /* Delay of 2 seconds */);
        mailCalendarNudgeCampaign.start();
    });

    /**
     * Mail warm campaign object
     */
    mailWarmWelcomeCampaign = new Campaign<CampaignModalConfig>({
        id: 'WARM_WELCOME_CAMPAIGN',
        rule: () => true,
        lightningId: CampaignLightningId.MiniWarmWelcome,
        actionTypes: { onUserDismiss: 'Primary', onUnmount: 'Primary' },
        campaignType: new CampaignModal(),
    });

    mailWarmWelcomeJourney = new Journey(async () => {
        await waitBeforeStart();
        mailWarmWelcomeCampaign.start();
    });

    /** Mail focused others campaign object */
    mailFocusedOthersCampaign = new Campaign<CampaignEmbeddedMessageConfig>({
        id: 'FOCUSED_OTHER_CAMPAIGN',
        rule: () => true,
        lightningId: CampaignLightningId.MiniMailFocusOthers,
        actionTypes: { onUserDismiss: 'Primary', onUnmount: null },
        campaignType: new CampaignEmbeddedMessage(),
    });

    /** Mail multi select campaign */
    mailMultiSelectCampaign = new Campaign<CampaignEmbeddedMessageConfig>({
        id: 'MULTI_SELECT_CAMPAIGN',
        rule: () => true,
        lightningId: CampaignLightningId.MiniMailMultiSelect,
        actionTypes: { onUserDismiss: 'Primary', onUnmount: null },
        campaignType: new CampaignEmbeddedMessage(),
    });

    /** Mail Edge upsell campaign */
    mailEdgeUpsellCampaign = new Campaign<CampaignEmbeddedMessageConfig>({
        id: 'EDGE_UPSELL_CAMPAIGN',
        rule: () => true,
        lightningId: CampaignLightningId.MiniMailEdgeUpsell,
        actionTypes: { onUserDismiss: 'Secondary', onUnmount: null, onCampaignClick: 'Primary' },
        campaignType: new CampaignEmbeddedMessage(),
    });

    isMailCampaignObjectsInitialized = true;
}

export function getMailCampaignObjects() {
    if (!isMailCampaignObjectsInitialized) {
        initializeMailCampaignObjects();
    }
    return {
        mailCalendarNudgeCampaign,
        mailCalendarNudgeJourney,
        mailWarmWelcomeCampaign,
        mailWarmWelcomeJourney,
        mailFocusedOthersCampaign,
        mailMultiSelectCampaign,
        mailEdgeUpsellCampaign,
    };
}
